import React, { useEffect, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserProfileDetails,
  handleScrollToBottom,
  handleShowAIScreen,
} from "../../../appStore/actions/AppState/action";
import {
  fetchOldMessageFromApi,
  handleDeleteGroupMessage,
  handleFetchOldMessage,
  handleGetStarMessages,
  handleStarMessage,
} from "../../../appStore/actions/ArkchatGroup/action";
import { groupMsgDeleteType } from "../../../utils/constant";
import StarMessageView from "./StarMessageView";
import GroupMessageView from "./GroupMessageView";
import TempMessageView from "./TempMessageView";
import PersonFloat from "../../../assets/images/chats/personFloatBtn.svg";
import AiFloat from "../../../assets/images/chats/aifloaticon.svg";  
import DirectMessageView from "./DirectMessageView";
import session, { findUser, setProfileData } from "../../../utils/helper";
import ProfileDetailModal from "../../../common/ProfileDetailModal";
import EmptyMsg from "./EmptyMsg";
import { useTranslation } from "react-i18next";
import GroupInfoHeader from "../Tabs/GroupInfoHeader";
import { colorSchemes, FloatBtnStyle, FloatImgStyle, fontSizeSchemes } from "../../../assets/commonFunction";
import SearchInputFromGroupInfo from "../Tabs/SearchInputFromGroupInfo";
import LableToolTip from "../../../common/LableToolTip";
import useAppSelectors from "../../../customHooks/useAppSelectors";

export const classes = {
  chatUserprofile: {
    bgcolor: "#E3E1E1",
    width: "30px",
    height: "30px",
    display: "flex",
    display: "-webkit-box",
    display: "-ms-flexbox",
    display: "-webkit-flex,",
    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",
    objectFit: "cover",
    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },
  highlight: {
    bgcolor: "blue",
  },
  chatUserprofile2: {
    bgcolor: "#E3E1E1",
    width: "25px",
    height: "25px",
    display: "flex",
    display: "-webkit-box",
    display: "-ms-flexbox",
    display: "-webkit-flex,",
    flex: "none",

    alignContent: "center",
    flexWrap: "wrap",
    justifyContent: "center",
    WebkitBoxPack: "center",
    msFlexPack: "center",
    borderRadius: "0.15rem",
    fontWeight: "500",
    img: {
      height: "100%",
      width: "100%",
      objectFit: "cover",
      borderRadius: "3px",
    },
  },
  userlink: {
    color: "#2C86FF",
    lineHeight: "15px",
    fontSize: "13px",
    fontWeight: "450",
    cursor: "pointer",
  },
  duetime: {
    color: "#000",
    opacity: "80%",
    fontSize: "13px",
    paddingTop: "1px",
  },
  userlink2: {
    color: "#2C86FF",
    display: "inline-block",
    fontSize: "0.75rem",
  },
  userInfo: {
    marginTop: "-5px !important",
    width: "100%",
  },
  tick: {
    objectFit: "cover",
    maxWidth: "17px",
    maxHeight: "6px",
    img: {
      width: "100%",
    },
  },
  pendingT: {
    borderRadius: "4px",
    padding: "5px 10px",
    height: "30px",
    textAlign: "center",
    maxHeight: "1.5rem",
    justifyContent: "center",
  },

  txt: {
    marginLeft: "2px !important;",
    color: colorSchemes.themeRedColor,
    fontSize: fontSizeSchemes.font12,
    fontWeight: 500,
  },
  chatRep: {
    background: "#E3E1E1",
    padding: "4px 10px",
    borderRadius: "3px",
    margin: "10px 0 8px",
    // cursor:"pointer"
  },
};

const MessageList = ({
  setMediaFilesOpen,
  setReplyParentMsg,
  handlegetThreadMessages,
  handleBacktoMessage,
  setMoveTopicTriggered,
  setMoveTopicMsgId,
  setisTopicOpen,
  handleReadStatusDrawer,
  handleSendTempMsg,
  handleClickTaskUpdate,
  progress,
  handleAddgroupMember,
  isSearchGroupInfoOpen,
  handleSearch,
  setIsSearchGroupInfoOpen,
  isPrivateChatOn,
  highlightText,
  searchInputValue,
}) => {

  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { currentUserData, selectedGroup, tempMsgList, showStarMessage, selectedTopic, groupmemberdetails, groupRecipientDetails, starMsgData, messageList } = useAppSelectors();
  const isScrollToBottom = useSelector((state) => state?.appStateData?.isScrollToBottom);
  const isThreadScreen = session.get("isThreadScreen"); 
  

  const chatContainerRef = useRef(null);
  const menuRef = useRef(null);
  const threeDotRef = useRef(null);
  const [isMoreMenuOpen, setMoreMenu] = useState(false);
  const [isDMMoreMenuOpen, setDMMoreMenuOpen] = useState(null);
  const [isDeleteGroupMsgOpen, setDeleteGroupMsgOpen] = useState(false);
  const [profileViewData, setProfileViewData] = useState("");
  const [isProfileViewOpen, setProfileViewModal] = useState(false);
  const [isDeleteGroupMsgOpenIndicatorId, setDeleteGroupMsgOpenIndicatorId] =
    useState(null);
  const [deleteGrpMsgType, setDeleteGrpMsgType] = useState("");
  const dispatch = useDispatch();
  const [isScrollingToTop, setIsScrollingToTop] = useState(false);
  const [localStarMsgData, setLocalStarMsgData] = useState([]);
  const [highlightedMessageId, setHighlightedMessageId] = useState(null);
  const [startTaskOpen, setStartTaskOpen] = useState(null);
  const [isShowGroupName, setIsShowGroupName] = useState(false);

  ////////
  const scrollToBottom = () => {
    if (chatContainerRef?.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    } 
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMoreMenu(null);
    }
  };
  const toggleItemMenu = (item) => {
    if (isMoreMenuOpen?.timetoken === item?.timetoken) {
      setMoreMenu(null);
    } else {
      setMoreMenu(item);
    }
  };

  const handleStartTask = (item) => {
    if (startTaskOpen?.timetoken === item?.timetoken) {
      setStartTaskOpen(null);
    } else {
      setStartTaskOpen(item);
    }
  };

  const handleDeleteGrpMsg = (msgData) => {
    if (deleteGrpMsgType === groupMsgDeleteType?.me) {
      dispatch(handleDeleteGroupMessage(msgData, false)).then((res) => {});
      setDeleteGrpMsgType("");
      setDeleteGroupMsgOpen(false);
      setDeleteGroupMsgOpenIndicatorId(null);
    } else if (deleteGrpMsgType === groupMsgDeleteType?.all) {
      dispatch(handleDeleteGroupMessage(msgData, true)).then((res) => {});
      setDeleteGrpMsgType("");
      setDeleteGroupMsgOpen(false);
      setDeleteGroupMsgOpenIndicatorId(null);
    }
  };
  const handleStarUnstarMsg = (timetoken, isalreadyStared) => {
    const reqBoby = {
      pn_id: selectedGroup?.pnId,
      timetoken: timetoken,
    };
    dispatch(
      handleStarMessage(
        reqBoby,
        selectedGroup?.pnId,
        selectedTopic,
        messageList,
        isThreadScreen
      )
    ).then((res) => {
      if (res?.status) {
        if (localStarMsgData?.includes(reqBoby?.timetoken)) {
          const updatedData = localStarMsgData?.filter(
            (item) => item !== reqBoby?.timetoken
          );
          setLocalStarMsgData(updatedData);
        } else if (
          !isalreadyStared?.includes(currentUserData?.id)
        ) {
          setLocalStarMsgData([...localStarMsgData, reqBoby?.timetoken]);
        }

        setMoreMenu(null);
        dispatch(handleGetStarMessages(selectedGroup?.pnId));
        //reqBobydispatch(handleFetchMessages({ groupId: selectedGroup?.id }));
      }
    });
  };
  const handleAiBtnCLick = () => {
    if (selectedGroup) {
      dispatch(handleShowAIScreen(true));
    }
  };
  // const handleRemoveStarScreen = () => {
  //   dispatch(handleStarMsgScreen(!showStarMessage));
  //   dispatch(handleFetchMessages(selectedGroup?.pnId, selectedTopic?.id));
  //   dispatch(handleScrollToBottom(true));
  // };

  const scrollToRepliedMessage = (messageId) => {
    setHighlightedMessageId(messageId);
    setTimeout(() => {
      setHighlightedMessageId(null);
    }, 2000);

    const repliedMessageElement = document.getElementById(
      `replied-message-${messageId}`
    );
    if (repliedMessageElement) {
      repliedMessageElement.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  ////
  // Debounce function to improve performance
  const debounce = (func, delay) => {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  };
  const handleScroll = debounce(() => {
    const activeChannel = selectedGroup?.pnId;

    if (chatContainerRef?.current) {
      const { scrollTop } = chatContainerRef.current;
      let shouldConsiderScrollTop = false;

      if (messageList?.length > 0) {
        shouldConsiderScrollTop = messageList[0]?.pnId === activeChannel;
      }

      const isNearTop =
        scrollTop <= 201 && shouldConsiderScrollTop && messageList?.length > 20;

      // Only update state if necessary
      if (isScrollingToTop !== isNearTop) {
        setIsScrollingToTop(isNearTop);
      }

      // Show group name when scrolling down (scrollTop > 0), hide when at top
      const shouldShowGroupName = scrollTop > 0;
      if (isShowGroupName !== shouldShowGroupName) {
        setIsShowGroupName(shouldShowGroupName);
      }
    }
  }, 100);

  const handleShowUserProfile = (userToFindData) => {
    let data = findUser(groupmemberdetails, userToFindData);

    if (!data) {
      setProfileViewModal(true);
      dispatch(getUserProfileDetails(userToFindData)).then((res) => {
        data = res;
        setProfileData(data, setProfileViewData, setProfileViewModal);
      });
    } else {
      setProfileData(data, setProfileViewData, setProfileViewModal);
    }
  };

  useEffect(() => {
    if (isScrollingToTop) {
      dispatch(handleScrollToBottom(false));

      const container = chatContainerRef.current;
      if (container) {
        // Save the current scroll position relative to the bottom
        const currentScrollPosition =
          container.scrollHeight - container.scrollTop;

        if (
          (selectedGroup?.isGroup || !selectedGroup?.isGroup) &&
          !isThreadScreen &&
          !showStarMessage
        ) {
          dispatch(
            handleFetchOldMessage(
              selectedGroup?.pnId,
              selectedTopic?.id,
              messageList[0]?.timetoken
            )
          ).then((res) => {
            if (res?.length > 0) {
              // After prepending messages, adjust the scroll position
              setTimeout(() => {
                container.scrollTop =
                  container.scrollHeight - currentScrollPosition;
              }, 0);
            } else {
              const page = Math.floor(messageList?.length / 50) + 1;
              dispatch(fetchOldMessageFromApi(selectedGroup, {}, page)).then(
                () => {
                  setTimeout(() => {
                    container.scrollTop =
                      container.scrollHeight - currentScrollPosition;
                  }, 0);
                }
              );
            }
          });
        } else if (showStarMessage) {
          const page = Math.floor(starMsgData?.messages?.length / 50) + 1;
          dispatch(handleGetStarMessages(selectedGroup?.pnId, page)).then(
            () => {
              setTimeout(() => {
                container.scrollTop =
                  container.scrollHeight - currentScrollPosition;
              }, 0);
            }
          );
        }
      }
    }
  }, [isScrollingToTop]);

  /////

  useEffect(() => {
    if (isScrollToBottom) {
      scrollToBottom();
    }
  }, [messageList, tempMsgList]);

  useEffect(() => {
    if (selectedGroup?.isGroup) {
      dispatch(handleGetStarMessages(selectedGroup?.pnId));
    }
  }, [dispatch, selectedGroup]);
  return (
    <>
      <Box display={"flex"} marginTop="8px">
        <ProfileDetailModal
          setProfileViewModal={setProfileViewModal}
          isProfileViewOpen={isProfileViewOpen}
          profileViewData={profileViewData}
          setProfileViewData={setProfileViewData}
        />
        {!selectedGroup?.isGroup && (
          <GroupInfoHeader
            setisTopicOpen={setisTopicOpen}
            setMediaFilesOpen={setMediaFilesOpen}
            handleSearch={handleSearch}
          />
        )}
      </Box>

     
      {/* 
      {isShowGroupName && (
        <Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            sx={
              {
                //background: "#E3E3E3",
              }
            }
          >
            <Box
              sx={{
                border: "2px solid transparent",
                borderRadius: "2px",
                background: "#E1E1E1",
                width: "230px",
                height: "30px",
                px: 2,
                py: 0.5,
                position: "relative",
                minWidth: "120px", // adjust as needed
                textAlign: "center",
              }}
            >
              <Typography
                fontSize={fontSizeSchemes.font14}
                fontWeight={400}
                color="#1A2B3C"
                title={`${selectedGroup?.name}${
                  selectedGroup?.isBuyerSellerGroup
                    ? " - Buyer/Seller Group"
                    : ""
                }`}
              >
                {`${selectedGroup?.name}${
                  selectedGroup?.isBuyerSellerGroup
                    ? " - Buyer/Seller Group"
                    : ""
                }`}
              </Typography>
              <Box
                sx={{
                  position: "absolute",
                  left: 0,
                  right: 0,
                  bottom: -6,
                  height: "4px",
                  //background: "#2C86FF",
                  //borderRadius: "2px",
                  mx: "auto",
                  width: "100%",
                }}
              />
            </Box>
          </Box>
        </Box>
      )} */}

      <Box
        maxWidth={"100%"}
        sx={{
          position: "relative",
          height: "100%",
          overflowY: "auto",
          scrollBehavior: "smooth",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#888",
            borderRadius: "3px",
          },
          "@media (max-width: 1194px)": {
            height: "69%",
          },
        }}
        ref={chatContainerRef}
        onScroll={handleScroll}
      >
        {(selectedGroup?.isGroup || !selectedGroup?.isGroup) &&
          messageList?.length === 0 &&
          tempMsgList?.length === 0 &&
          !showStarMessage && (
            <EmptyMsg
              content={
                selectedGroup?.isGroup ? appContent?.KEY207 : appContent?.KEY208
              }
            />
          )}

        {showStarMessage && selectedGroup?.isGroup ? (
          <Box>
            {starMsgData?.messages?.length > 0 &&
              starMsgData?.messages?.map((item) => (
                <StarMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  key={item?.timetoken + "starmessageGrpList"}
                  item={item}
                  isMoreMenuOpen={isMoreMenuOpen}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  isDeleteGroupMsgOpenIndicatorId={
                    isDeleteGroupMsgOpenIndicatorId
                  }
                  handleClickTaskUpdate={handleClickTaskUpdate}
                  isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                  handleReadStatusDrawer={handleReadStatusDrawer}
                  setisTopicOpen={setisTopicOpen}
                  setMoveTopicMsgId={setMoveTopicMsgId}
                  setMoveTopicTriggered={setMoveTopicTriggered}
                  setDeleteGroupMsgOpenIndicatorId={
                    setDeleteGroupMsgOpenIndicatorId
                  }
                  setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                  handlegetThreadMessages={handlegetThreadMessages}
                  setMoreMenu={setMoreMenu}
                  menuRef={menuRef}
                  isThreadScreen={isThreadScreen}
                  selectedGroup={selectedGroup}
                  toggleItemMenu={toggleItemMenu}
                  startTaskOpen={startTaskOpen}
                  setStartTaskOpen={setStartTaskOpen}
                  handleStartTask={handleStartTask}
                  handleStarUnstarMsg={handleStarUnstarMsg}
                  handleDeleteGrpMsg={handleDeleteGrpMsg}
                  setHighlightedMessageId={setHighlightedMessageId}
                  bgcolor={
                    highlightedMessageId === item?.temp_timetoken
                      ? "#F9F8F8"
                      : "transparent"
                  }
                  scrollToRepliedMessage={scrollToRepliedMessage}
                  highlightText={highlightText}
                  searchInputValue={searchInputValue}
                />
              ))}
          </Box>
        ) : (
          <>
            {messageList?.length > 0 &&
              messageList?.map((item, i) => (
                <Box key={"GroupMessageViewParent" + i}>
                  {item?.participants?.includes(
                    currentUserData?.id
                  ) && (
                    <GroupMessageView
                      item={item}
                      groupRecipientDetails={groupRecipientDetails}
                      key={item?.temp_timetoken + "GroupmessageView" + i}
                      isMoreMenuOpen={isMoreMenuOpen}
                      handleShowUserProfile={handleShowUserProfile}
                      threeDotRef={threeDotRef}
                      currentUserData={currentUserData}
                      isDeleteGroupMsgOpenIndicatorId={
                        isDeleteGroupMsgOpenIndicatorId
                      }
                      handleClickTaskUpdate={handleClickTaskUpdate}
                      isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                      handleReadStatusDrawer={handleReadStatusDrawer}
                      setisTopicOpen={setisTopicOpen}
                      setMoveTopicMsgId={setMoveTopicMsgId}
                      setMoveTopicTriggered={setMoveTopicTriggered}
                      setDeleteGroupMsgOpenIndicatorId={
                        setDeleteGroupMsgOpenIndicatorId
                      }
                      setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                      progress={progress}
                      handlegetThreadMessages={handlegetThreadMessages}
                      setMoreMenu={setMoreMenu}
                      menuRef={menuRef}
                      isThreadScreen={isThreadScreen}
                      selectedGroup={selectedGroup}
                      toggleItemMenu={toggleItemMenu}
                      startTaskOpen={startTaskOpen}
                      setStartTaskOpen={setStartTaskOpen}
                      handleStartTask={handleStartTask}
                      handleStarUnstarMsg={handleStarUnstarMsg}
                      handleDeleteGrpMsg={handleDeleteGrpMsg}
                      setDeleteGrpMsgType={setDeleteGrpMsgType}
                      highlightText={highlightText}
                      searchInputValue={searchInputValue}
                      localStarMsgData={localStarMsgData}
                      bgcolor={
                        highlightedMessageId === item?.temp_timetoken
                          ? "#F9F8F8"
                          : "transparent"
                      }
                      scrollToRepliedMessage={scrollToRepliedMessage}
                      dispatch={dispatch}
                    />
                  )}
                </Box>
              ))}
            {tempMsgList?.length > 0 &&
              selectedGroup?.isGroup &&
              tempMsgList?.map((item, i) => (
                <TempMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  selectedGroup={selectedGroup}
                  item={item}
                  key={item?.temp_timetoken + "tempMsg"}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  handleSendTempMsg={handleSendTempMsg}
                  progress={progress}
                />
              ))}
          </>
        )}

        <>{/* This is for Render DM */}</>
        {!selectedGroup?.isGroup && (
          <>
            {messageList?.length > 0 &&
              messageList?.map((item) => (
                <DirectMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  isDMMoreMenuOpen={isDMMoreMenuOpen}
                  setDMMoreMenuOpen={setDMMoreMenuOpen}
                  isDeleteGroupMsgOpenIndicatorId={
                    isDeleteGroupMsgOpenIndicatorId
                  }
                  isDeleteGroupMsgOpen={isDeleteGroupMsgOpen}
                  setDeleteGrpMsgType={setDeleteGrpMsgType}
                  setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                  setDeleteGroupMsgOpenIndicatorId={
                    setDeleteGroupMsgOpenIndicatorId
                  }
                  handleDeleteGrpMsg={handleDeleteGrpMsg}
                  item={item}
                  key={item?.temp_timetoken + "Directmessage"}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  handleSendTempMsg={handleSendTempMsg}
                  setReplyParentMsg={setReplyParentMsg}
                  bgcolor={
                    highlightedMessageId === item?.temp_timetoken
                      ? "#F9F8F8"
                      : "transparent"
                  }
                  scrollToRepliedMessage={scrollToRepliedMessage}
                />
              ))}
            {tempMsgList?.length > 0 &&
              tempMsgList?.map((item, i) => (
                <TempMessageView
                  handleShowUserProfile={handleShowUserProfile}
                  selectedGroup={selectedGroup}
                  item={item}
                  key={item?.temp_timetoken + "DirecttempMsg"}
                  threeDotRef={threeDotRef}
                  currentUserData={currentUserData}
                  handleSendTempMsg={handleSendTempMsg}
                  progress={progress}
                />
              ))}
          </>
        )}
      </Box>
      {/* Floating PersonFloat Button */}
      {selectedGroup?.isGroup && isPrivateChatOn ? (
        <LableToolTip title={appContent?.KEY254}>
        <Box
          onClick={handleAiBtnCLick}
          sx={FloatBtnStyle}
        >
          <img
            src={AiFloat}
            alt="Person Float"
            style={FloatImgStyle}
          />
        </Box>
        </LableToolTip>
      ) : (
        <></>
      )}
    </>
  );
};

export default MessageList;
